import Hash from "./component-library465.mjs";
import ListCache from "./component-library424.mjs";
import Map from "./component-library431.mjs";
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map || ListCache)(),
    "string": new Hash()
  };
}
export {
  mapCacheClear as default
};
